import { api, useRoleConf, useSuspenseQuery } from "../../../hooks"
import type { Period } from "../../../types"
import { getPeriodDateRange, stringifyQueryObj } from "../../../utils"
import { apiRoleConf } from "./financialDataSales.apiRoleConf"
import type { ApiSales } from "./financialDataSales.model"

// biome-ignore lint/suspicious/noExplicitAny: qs.stringify
type Params = Record<string, any>

export const useFinancialDataSalesApi = ({
  period,
  pharmacyId,
  ...params
}: { period: Period; pharmacyId?: string } & Params) => {
  const dateRange = getPeriodDateRange(period)

  const { queryKey, endpoint } = useRoleConf(apiRoleConf(pharmacyId))

  const queryParams = stringifyQueryObj({ ...dateRange, ...params })

  // GET
  const { data, isLoading } = useSuspenseQuery({
    queryKey: [...queryKey, period, ...Object.values(params).filter(Boolean)],
    queryFn: () => api.get<ApiSales>(`${endpoint}?${queryParams}`),
  })

  return { data, isLoading }
}
